<template>
  <div class="select">
    <select :class="customClasses" @change="travelToCity()" v-model="city">
      <option
        v-for="(cityOption, index) in citiesOptions"
        :value="cityOption.value"
        :key="index"
      >
        {{ cityOption.name }}
      </option>
    </select>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "CitiesSelector",
  props: ["currentCity", "customClasses"],
  data() {
    return {
      selected:false,
      city: false,
      opened: false,
      cities: [],
      citiesSelect: [],
    };
  },
  computed: {
    citiesOptions() {
      const citiesList = _.map(window.passdata.citiesSelect, (city) => {
        return {
          name: city.name,
          value: city.url,
        };
      });

      citiesList.unshift({
        name: "Sélectionner une ville",
        value: false,
      });

      return citiesList;
    },
  },
  methods: {
    travelToCity() {
      if (this.city != false) {
        window.location = this.city;
        localStorage.setItem("city", this.city);
      } else {
        this.city = false;
        localStorage.setItem("city", false);
        window.location = "/";
      }
    },
  },
  beforeMount() {
    this.citiesSelect = window.passdata.citiesSelect;
    if (this.currentCity) {
      this.city = this.currentCity;
    } else {
      this.city = localStorage.getItem("city");
    }
    localStorage.setItem("city", this.city);
  },
};
</script>
